import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { getIsCurrentTrial } from 'pricing-pages-lib/utils/trialsUtils';
import { transformState } from './SelectorUtils';
export const activeTrialsSelector = state => {
  return state.activeTrials;
};
export const getIsCurrentTrialSelector = createSelectorFromUtil(getIsCurrentTrial, transformState);